var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCl1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 244,
    viewBox: "0 0 259 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.9233 29.958C35.2993 48.7709 20.9895 74.5967 16.5035 102.906C12.0176 131.215 17.642 160.199 32.3903 184.776L34.5065 183.506C20.0566 159.426 14.546 131.028 18.9412 103.292C23.3364 75.5557 37.3568 50.2524 58.5433 31.8201L56.9233 29.958Z",
    stroke: "#A2F8C5",
    strokeOpacity: 0.75,
    strokeWidth: 30
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCl1);
export default __webpack_public_path__ + "static/media/cl1.7cddd6e67f19c876400a436952964252.svg";
export { ForwardRef as ReactComponent };